import { ImageList } from '../../shared';

import * as garboscore from './garboscore.png';

export const garboScoreImages: ImageList = [
    {
        caption: 'GarboScore Landing Page',
        src: garboscore.default,
    },
];

export * from './mix';
export * from './sputter';
